// Thanks to git copilot
export function deepMerge(into: any, from: any): any {
    for (const key in from) {
        if (into[key] && typeof into[key] === "object") {
            deepMerge(into[key], from[key]);
        } else {
            into[key] = from[key];
        }
    }
}